module.exports = __webpack_public_path__ + "img/03-full.3b263f0f.jpg";